import { render } from "./SystemGateways.vue?vue&type=template&id=1e120a87&scoped=true&ts=true"
import script from "./SystemGateways.vue?vue&type=script&lang=ts"
export * from "./SystemGateways.vue?vue&type=script&lang=ts"

import "./SystemGateways.vue?vue&type=style&index=0&id=1e120a87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e120a87"]])

export default __exports__